<div class="progress-bar-wrapper">
    <mat-progress-bar [value]="progressValue" [color]="progressColor" *ngIf="progressValue < 100 || progressValue === 0">
    </mat-progress-bar>
</div>
